import { CommentTwoTone } from '@mui/icons-material';
import { Divider, List, Stack } from '@mui/material';
import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { IParams, Page, PermissionKeys, useHasPermission, useSelectedOrganisation, Widget } from '../../../shared';
import { CommentComponent, DuplicatesWarning, SaveCommentComponent, SupportCaseTitle } from '../../components';
import { useGetComments, useGetSupportCase } from '../../hooks';

export const SupportCaseCommentsPage: FC = () => {
    const { t } = useTranslation();
    const { hasPermission } = useHasPermission();
    const hasWritePermission = hasPermission(PermissionKeys.SUPPORT_CASE_COMMENTS_WRITE);
    const navigate = useNavigate();
    const { organisation } = useSelectedOrganisation();
    const { id } = useParams<keyof IParams>() as IParams;
    const { data: supportCase } = useGetSupportCase(id);
    const { data: comments } = useGetComments(id, organisation ? organisation.id : '', {
        pageSize: 100,
    });

    return (
        <Page onBack={() => navigate(-1)} title={supportCase && <SupportCaseTitle supportCase={supportCase} />}>
            <Stack spacing={2}>
                <DuplicatesWarning supportCaseId={id} />
                <Widget icon={<CommentTwoTone color="primary" />} title={t('comments')}>
                    {hasWritePermission && (
                        <Stack spacing={2}>
                            <SaveCommentComponent supportCase={id} />
                            <Divider />
                        </Stack>
                    )}

                    <List sx={{ width: '100%' }}>
                        {comments?.data.map((comment) => (
                            <Fragment key={comment.id}>
                                <CommentComponent supportCase={id} comment={comment} />
                                <Divider variant="inset" component="li" />
                            </Fragment>
                        ))}
                    </List>
                </Widget>
            </Stack>
        </Page>
    );
};
